import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {TasksService} from '../../../tasks/tasks.service';
import {TasksModel} from '../../../tasks/models/tasks.model';

@Component({
    selector: 'app-journey-list-template-checkbox',
    templateUrl: './list-template-checkbox.component.html',
    styleUrls: ['./list-template-checkbox.component.scss']
})
export class LearningJourneyListTemplateCheckboxComponent implements OnInit {

    @Output() goToStage: EventEmitter<number> = new EventEmitter();
    @Input() task: TasksModel = null;
    @Input() disabled = false;
    @Input() for_manager = false;
    @Input() for_coach = false;
    @Input() can_be_failed = false;

    canChangeStatus = false;

    constructor(
        private tasksService: TasksService
    ) {
        // this.canChangeStatus = environment.theme !== 'veeam';
    }

    ngOnInit() {
    }

    runTask(task: TasksModel) {
        if (this.disabled) {
            return false;
        }

        // TODO Quick fix to make file widget act as a link
        if (task.section === 'file' && !!task.details.file.url) {
            task.url = task.details.file.url;
        }
        this.tasksService.runTask(task);
    }

    changeStatus(task: TasksModel) {
        this.tasksService.updateTaskStatus(task);
    }

}
